import React, { useState } from "react";
import TokenVariable from "Components/common/TokenVariable";
import TextArea from "Components/common/TextArea";
import { ReactComponent as WarningIcon } from "Assets/svg/warningIcon.svg";

export const NotesInput = props => {
  const {
    notes = "",
    action = () => { },
    pageType = "Sequences",
    setCursorPostion = () => { },
    labelText = "Notes",
    errorMsg = false,
    showLimit = false,
    showLimitText = "",
    isLinkedInPremium = false,
    showLinkedInWarning = false,
    isLinkedInAutoStage = false,
    isLiAutoStageAndRequestType = false,
    charLength = 0,
    showDateTokens = true
  } = props || {};

  const [showTokenVariable, setShowTokenVariable] = useState(false);

  const addNewTokenVariable = (value = "") => {
    window &&
      window.getSelection() &&
      window.getSelection().deleteFromDocument();
    action(value, true);
    setShowTokenVariable(false);
  };

  const shouldShowLiLimitWarning =
    showLinkedInWarning &&
    !isLinkedInPremium &&
    showLimit &&
    notes?.length >= 1;

  return (
    <div className="notesInput">
      <TextArea
        id="taskNotes"
        rows={5}
        value={notes}
        onChangeEvent={e => action(e.target.value)}
        labelText={labelText}
        showLimit={showLimit}
        showLimitText={showLimitText}
        setCursorPostion={setCursorPostion}
      />
      {isLiAutoStageAndRequestType && charLength >= 301 && (
        <div className="charLimitWarning">
          Max 300 characters allowed.
        </div>
      )}
      {isLinkedInAutoStage && (
        <div
          className={`liLimitWarningWrapper${shouldShowLiLimitWarning ? " isVisible" : ""
            }`}
          aria-hidden={!shouldShowLiLimitWarning}
        >
          <div className="liLimitWarning">
            <div className="warningIcon">
              <WarningIcon />
            </div>
            <span>
              You're using a standard LinkedIn account. Free plans allow only 5
              message requests/month, so this step may fail. Connect Sales
              Navigator for reliable sending.
            </span>
          </div>
        </div>
      )}
      <div className="insertVariableBtn">
        <span onClick={() => setShowTokenVariable(!showTokenVariable)}>
          {`{ X } Insert Variable`}
        </span>
        {showTokenVariable && (
          <TokenVariable
            tokenCbk={addNewTokenVariable}
            closeCbk={() => setShowTokenVariable(false)}
            pageType={pageType}
            showInboxTokens={false}
            showDateTokens={showDateTokens}
          />
        )}
      </div>
      {errorMsg && (
        <span className={`errMsgText`}>{"Message cannot be empty"}</span>
      )}
    </div>
  );
};

export default NotesInput;
